import axios from "axios";
import { config } from "../config";
import { showPopupToastMsg } from "../helpers";

export class RiskLevelsService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "risk-levels");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  public listSettings = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "risk-levels/settings");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  /*********** Create ***********/
  public create = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(serverUrl + "risk-levels", data);
      return response.data;
    } catch (error: any) {
      console.log(error);
      showPopupToastMsg("error", error.message);
    }
  };

  /*********** Update ***********/
  public update = async (id: number, data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.put(serverUrl + `risk-levels/${id}`, data);
      return response.data;
    } catch (error: any) {
      showPopupToastMsg("error", error.message);
    }
  };

  /*********** DELETE ***********/
  public delete = async (id: number): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.delete(serverUrl + `risk-levels/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return { message: "error" };
    }
  };
}
